import React, { useState } from "react";
import { API_URL } from "../constants";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Toast from "../DetailsCompteur/Toast";

export default function ChangePasswordForm({ id, token }) {
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [toast, setToast] = useState({ type: '', message: '' });
  const navigate = useNavigate();

  const showToast = (type, message) => {
    setToast({ type, message });
    setTimeout(() => setToast({ type: '', message: '' }), 3000);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (password.length < 8) {
      showToast('error', 'Le mot de passe doit contenir au moins 8 caractères.');
      return;
    }

    setSubmitting(true);
    try {
      const response = await axios.post(`${API_URL}/user/changemdpAdmin`, {
        id: id,
        password: password,
      }, {
        headers: {
          mode: "cors",
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
      });

      showToast('success', response.data.message || 'Mot de passe mis à jour !');
      setPassword("");
    } catch (error) {
      if (error.response?.status === 401) {
        alert("ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer.");
        localStorage.clear();
        navigate("/login");
        return;
      }
      showToast('error', 'Échec de la mise à jour du mot de passe.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <p className="text-sm font-medium text-gray-600 mb-3">Changer le mot de passe</p>
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
        <input
          className="flex-1 border border-gray-300 rounded-lg px-4 py-3 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400"
          onChange={(e) => setPassword(e.target.value)}
          value={password}
          placeholder="Nouveau mot de passe"
          name="mdp"
          type="password"
        />
        <button
          type="submit"
          disabled={submitting}
          className="bg-gradient-to-r from-purple-500 to-indigo-500 text-white px-6 py-3 rounded-lg shadow-md hover:shadow-lg transition-all duration-200 font-medium disabled:opacity-50 whitespace-nowrap"
        >
          {submitting ? 'Mise à jour...' : 'Valider'}
        </button>
      </form>
      <Toast type={toast.type} message={toast.message} />
    </div>
  );
}